import React from 'react';
import LazyLoad from 'react-lazyload';
import ReactSlick from 'react-slick';
import axios from 'axios';
import getUid from '../../../../utils/snowplow';
import uuid4 from '../../../../utils/uuid';
import Product from '../../../../reusable-components/Product/Product';
import ArrowSvg from '../../icons/ArrowSvg';
import SmartImage from '../../subcomponents/SmartImage';
import gtmPusher from '../../../../utils/gtmPusher';
import findAltText from '../../utils';

import './productSlider.scss';

class ProductSlider extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      apiLoaded: false,
      isDragging: false,
    };
  }

  componentDidMount() {
    let apiUrl = '/api/products/batch/?list=';
    if (this.props.isBootroom) apiUrl = 'https://www.unisport.dk/api/products/batch/?list=';

    if (this.props.element.sliderType.includes('products') || this.props.element.sliderType.includes('deals')) {
      const productIdList = (this.props.campaignType === 'general' && this.props.element.notUsingContentBlock) ? this.props.element.productList : window.campaign_data.campaign_translations.blocks[this.props.element.sliderType];
      axios.get(`${apiUrl}${productIdList}`)
        .then((response) => {
          const productIds = response.data.products.map(product => product.id);
          window.ua('trackStructEvent', 'slider', 'display', uuid4(), productIds);
          this.handleAnalytics(response.data.products, `product slider: ${this.props.element.sliderType}`);
          this.setState({
            products: this.filterIds(response.data.products),
            apiLoaded: true,
          });
        });
    } else {
      const refId = uuid4();
      const algorithmOptions = {
        product_id: this.props.element.productId || null,
      };
      axios.get(`${window.config.analytics_host}/api/v1/${this.props.element.sliderType}/`, {
        params: {
          ...algorithmOptions,
        },
      }).then((recommendations) => {
        const productIds = recommendations.data.payload.products.map(i => i.product_id);
        axios.get(`${apiUrl}${productIds.join(',')}`).then((response) => {
          window.ua('trackStructEvent', 'slider', 'display', refId, productIds);
          this.handleAnalytics(response.data.products, `product slider: ${this.props.algorithm}`);
          this.setState({
            products: response.data.products,
            apiLoaded: true,
          });
        });
      });
    }
  }

  handleAnalytics = (products, list) => {
    // GOOGLE ANALYTICS
    const ecommerceObj = {
      event: 'impressionView',
      eventCategory: 'ecommerce',
      eventAction: 'impression view',
      eventLabel: 'list',
      eventValue: 0,
      eventNonInteraction: true,
      currencyCode: products.length > 0 ? products[0].currency : 'N/A',
      list,
    };
    const productArr = products.map((product, i) => {
      return {
        ...product,
        product: product.name,
        quantity: 1,
        unit_net: product.prices.min_price,
        size: null,
        variant: '',
        position: i,
      };
    });
    gtmPusher(ecommerceObj, productArr);
    // -- END GOOGLE ANALYTICS --
  }

  setSliderBackground = (sliderType) => {
    switch (sliderType) {
      case 'productsboot':
        return '050-slider-boots';

      case 'productsboot2':
        return '052-slider-boots2';

      case 'productsboot3':
        return '053-slider-boots3';

      case 'productstraining':
        return '150-slider-training';

      case 'productsglove':
        return '250-slider-gloves';

      default:
        return '170-slider-lifestyle';
    }
  };

  filterIds(products) {
    const filteredProducts = [];
    products.forEach((product) => {
      if (!filteredProducts.includes(product.id)) {
        filteredProducts.push(product);
      }
    });
    return filteredProducts;
  }

  render() {
    const {
      campaignType, order, version,
    } = this.props;
    const uppercaseLetters = this.props.url.generalData ?
      this.props.url.generalData.uppercaseLetters
      : false;
    const {
    svgArrowColor, 
    sliderType, 
    noBackground,
    backgroundColor, 
    hide, 
    useGradient,
    backgroundGradient, 
    gradientDirection, 
    type,
    productSliderNumber, 
    anchorName, 
    titleColor, 
    content,
    titleHTag, 
    useMobileText, 
    mobileTitleColor,
    } = this.props.element;
    const { slug, imagePattern } = this.props.url;
    const translations = window.campaign_data.campaign_translations.blocks;

    // slick slider arrows
    const PrevArrow = ({ className, onClick }) => {
      return (
        <div className={`${className} arrowLeft arrowSliderProduct`} aria-label="Previous Slide" onClick={onClick} role="button" tabIndex="0">
            <ArrowSvg svgColor={svgArrowColor} />
        </div>
      );
    };
    const NextArrow = ({ className, onClick }) => {
      return (
        <div className={`${className} arrowRight arrowSliderProduct`} aria-label="Next Slide" onClick={onClick} role="button" tabIndex="0">
            <ArrowSvg svgColor={svgArrowColor} />
        </div>
      );
    };

    const params = {
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: false,
      arrows: true,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      infinite: false,
      lazyLoad: true,
      touchThreshold: 15,
      speed: 300,
      beforeChange: () => this.setState({ isDragging: true }),
      afterChange: () => this.setState({ isDragging: false }),
      responsive: [
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 1390,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 3000,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
          },
        },
      ],
    };

    const sliderBackground = this.setSliderBackground(sliderType);

    let displayTitleColor = titleColor;
    if (useMobileText && window.innerWidth < 768) displayTitleColor = mobileTitleColor;

    // change HTML tag of the component title for seo purpose
    const classes = uppercaseLetters ? 'productSlider-title title title--uppercase' : 'productSlider-title title';
    const titleTranslation = translations[`${content}title`];
    const titleObj = {
      h2: <h2 className={classes} style={{ color: displayTitleColor }}>{titleTranslation}</h2>,
      h3: <h3 className={classes} style={{ color: displayTitleColor }}>{titleTranslation}</h3>,
      p: <p className={classes} style={{ color: displayTitleColor }}>{titleTranslation}</p>,
    };
    const title = titleObj[titleHTag];

    // product slider section classes based on campaign type
    let sectionClasses = ['component', 'productSlider-section'];
    switch (campaignType) {
      case 'sale':
        sectionClasses = [...sectionClasses];
        break;
      case 'general':
        sectionClasses = [...sectionClasses];
        break;
      case 'boots':
        if (noBackground) sectionClasses.push('smart-section');
        break;
      default:
        if (noBackground) sectionClasses.push('smart-section');
        break;
    }
    let styler = {};
     if (noBackground && useGradient && gradientDirection === 'leftToRight') {
       styler = { background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && useGradient && gradientDirection === 'topToBottom') {
       styler = { background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && !useGradient) {
       styler = { background: backgroundColor };
    } else {
       styler = {};
    }
    let component = null;
    if (!hide) {
      component = (
        <section
          id={campaignType === 'sale' || campaignType === 'general' ? anchorName : ''}
          className={sectionClasses.join(' ')}
          style={styler}
          dataorder={order}
          datatype={type}
        >
          {!noBackground && campaignType !== 'sale' &&
            <SmartImage
              slug={slug}
              name={campaignType !== 'general' ? `${sliderBackground}${imagePattern}` : `170-product-slider${productSliderNumber}${imagePattern}`}
              version={version}
              campaignType={campaignType}
              className={campaignType === 'general' ? 'heightBackground' : ''}
              alt={findAltText(`Product Slider Background ${productSliderNumber}`, titleTranslation)}
            />
          }
          <div className={campaignType === 'sale' || (campaignType === 'general' && noBackground) ? 'mainWidth sale' : 'mainWidth'}>
            {(campaignType === 'sale' || campaignType === 'general') && title}
            {this.state.apiLoaded &&
              <div className={campaignType === 'sale' || (campaignType === 'general' && noBackground) ? 'productSlider saleComp' : 'productSlider'}>
                <LazyLoad height={500} throttle={300}>
                  <ReactSlick {...params}>
                    {this.state.products.length > 0 && this.state.products.map((product, i) => {
                          return i <= this.state.products.length ? (
                            <div key={`${product.id}-${this.props.addToCartCta}`}>
                              <Product
                                isDragging={this.state.isDragging}
                                refPos={i}
                                isCampaign
                                product={product}
                                commonTranslations={window.campaign_data.common_translations.blocks}
                                isBootroom={this.props.isBootroom}
                                // addToCartForm
                                sliderType="campaign product slider"
                                slickSlider
                              />
                            </div>
                          ) : null;
                      })
                    }
                  </ReactSlick>
                </LazyLoad>
              </div>
            }
          </div>
        </section>
      );
    }

    return (
      <React.Fragment>
        { component }
      </React.Fragment>
    );
  }
}

export default ProductSlider;
